import React from 'react';

const Footer = ({ copyright, navLinks = [] }) => (
  <footer style={{
    backgroundColor: '#1e293b',
    color: '#cbd5e1',
    padding: '40px 20px',
    marginTop: '60px',
    fontFamily: "'Inter', sans-serif"
  }}>
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '20px'
    }}>
      {copyright && (
        <div>
          <p style={{ margin: 0, fontSize: '0.9rem' }}>{copyright}</p>
        </div>
      )}
      {navLinks.length > 0 && (
        <nav style={{ display: 'flex', gap: '30px' }}>
          {navLinks.map(link => (
            <a
              key={link.href}
              href={link.href}
              style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.9rem', transition: 'color 0.2s ease' }}
              onMouseOver={(e) => { e.currentTarget.style.color = '#ffffff'; }}
              onMouseOut={(e) => { e.currentTarget.style.color = '#cbd5e1'; }}
            >
              {link.label}
            </a>
          ))}
        </nav>
      )}
    </div>
  </footer>
);

export default Footer;
